import script from "./DiffScopeBoundaryLimits.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiffScopeBoundaryLimits.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__